<template>

  <section class="tables">

    <div class="page-account">
      <div class="page-account__accounts">
        <h1 class="page-title">
          <span class="menu-icon">
            <i class="mdi mdi-web"></i>
          </span>
        </h1>
<!--        <div class="website-list">-->
<!--          <div class="website-list__website-container" v-for="(value, key) in websitesList" :key="key">-->
<!--            <p class="float-left">{{value.name}}</p>-->
<!--            <div v-if="!value.created" class="float-right">-->
<!--              <b-spinner class="float-right" variant="primary" label="Spinning"></b-spinner>-->
<!--              <p class="float-right small mr-3 mt-1">Prismyk is installing your website.</p>-->
<!--            </div>-->
<!--            <div v-else class="float-right">-->
<!--              <router-link class="float-right mr-3" to="#">Plan</router-link>-->
<!--              <router-link class="float-right mr-3" to="#">Domain</router-link>-->
<!--              <a class="float-right mr-3" target="_blank" :href="'https://' + value.slug + '.prismyk.com/wp-admin'">Admin</a>-->
<!--              <a class="float-right mr-3" target="_blank" :href="'https://' + value.slug + '.prismyk.com'">View</a>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="website-list__bottom">

        </div>
      </div>
    </div>
    <div class="page-header">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0);">Table</a></li>
          <li class="breadcrumb-item active" aria-current="page">Basic Table</li>
        </ol>
      </nav>
    </div>
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">

            <b-button v-b-modal.modal-new-website class="float-right" variant="primary">Create a new website</b-button>
            <b-modal
                id="modal-new-website"
                ref="modal"
                title="Submit Your Name"
                @show="resetModal"
                @hidden="resetModal"
                @ok="handleOk"
            >
              <form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group
                    label="Name"
                    label-for="name-input"
                    invalid-feedback="Name is required"
                    :state="nameState"
                >
                  <b-form-input
                      id="name-input"
                      v-model="name"
                      :state="nameState"
                      required
                  ></b-form-input>
                </b-form-group>
              </form>
            </b-modal>


            <h4 class="card-title">Websites</h4>
            <p class="card-description">
              For displaying tabular data. <code>&lt;b-table&gt;</code> supports pagination, filtering, sorting, custom rendering, events, and asynchronous data.
            </p>
            <b-table responsive :items="items"></b-table>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  name: 'Pricing',
  data () {
    return {
      websitesList: {},
      items: []
    }
  },
  props: {
    lng: String,
    langKeys: Object,
    setActualLng: Function,
    setSwitch: Function,
    lngSwitch: Object,
    getHomeFilters: Function,
    setUserInfos: Function,
    hideLoader: Function,
    showLoader: Function,
    setToken: Function,
    getImages: Function,
    signUpMessage: String,
    imageSearch: String,
    userEmail: String,
    newUser: Function,
    getWebsitesList: Function
  },
  watch: {
    websitesList (to, from) {
      this.items = []
      for (const i in this.websitesList) {
        this.items.push({
          name: this.websitesList[i].name,
          created: this.websitesList[i].created,
          slug: this.websitesList[i]['slug'],
          actions:true
        })
      }
    }
  },
  components: {
  },
  computed: {

  },
  methods: {
    createWebsite (event) {
      event.preventDefault()
      alert(JSON.stringify(this.form))
      this.newUser(this.form)
      return false
    },
    async checkWebsites () {
      this.websitesList = await this.getWebsitesList()
      setTimeout(this.checkWebsites, 1000)
    }
  },
  created () {},
  async mounted () {
    this.checkWebsites()
  }
}
</script>